<template>
  <!-- After-login banner: kept outside .popup_wrap, which is a fixed
       full-screen layer that would swallow clicks meant for the overlay -->
  <div
    v-if="step == 'after-login'"
    class="after-login-banner"
    @click.self="$emit('close')"
  >
    <div class="banner-inner">
      <a
        class="banner-close"
        href="javascript:void(0);"
        @click="$emit('close')"
      >
        <CloseBlue />
      </a>
      <img :src="`${publicPath}assets/img/layout/Banner.png`" alt="" />
    </div>
  </div>
  <div v-else class="pop_enterApp popup_wrap" style="display:block">
    <div class="popup_in">
      <div class="popup">
        <div class="popup_close_blue">
          <a href="javascript:void(0);" @click="$emit('close')">
            <CloseBlue />
          </a>
        </div>
        <div class="pop_enterApp-head bg--white">
          <logoMedical />
        </div>
        <!-- Desktop QR-->
        <div
          v-show="step == 'init-desktop'"
          class="pop_enterApp-bottom tx--white"
        >
          <div class="title tx--white">
            היי דוקטורס,
            <br />
            כל מה שצריך במקום אחד
            <b class="bold block">עכשיו גם מהנייד</b>
          </div>
          <div class="text--28 ft--400">סרקו והורידו</div>
          <img class="QR" src="../../assets/img/layout/QR.png" />
          <a
            class="no_qr_link text ft--400"
            href="javascript:void(0);"
            @click="$emit('close')"
          >
            המשך לאתר
          </a>
        </div>
        <!-- Mobile -->
        <div
          v-show="step == 'init-mobile'"
          class="pop_enterApp-bottom tx--white"
        >
          <div class="title tx--white">
            היי דוקטורס,
            <br />
            כל מה שצריך במקום אחד
            <b class="bold m-block">עכשיו גם מהנייד</b>
          </div>
          <div class="text--28 ft--400">להורדת האפלקציה</div>
          <div class="hold-app-store flex flex--content--center">
            <a
              href="https://play.google.com/store/apps/details?id=com.hmczimun.hmcappliction"
              target="_blank"
            >
              <img src="assets/img/svg/google-play.svg" alt="" />
            </a>
            <a
              href="https://apps.apple.com/il/app/mymedical-doctors/id1619098479"
              target="_blank"
            >
              <!-- href="https://apps.apple.com/app/idcom.hmczimun.hmcappliction" -->
              <!-- https://onelink.to/a59xnr -->
              <img src="assets/img/svg/app-store1.svg" alt="" />
            </a>
          </div>
          <div class="text--28">או</div>
          <a
            class="text--28 tx--under ft--400 tx--white block"
            style="margin-top:5px"
            href="javascript:void(0);"
            @click="$emit('close')"
          >
            לגלישה באתר מותאם
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="bgblack"></div> -->
  </div>
</template>

<script>
import CloseBlue from "../../assets/img/svg/close-blue.svg";
import logoMedical from "../../assets/img/svg/logo-myMedical.svg";

export default {
  name: "EnterPop",
  components: { CloseBlue, logoMedical },
  data() {
    return {
      isMobile: false,
      publicPath: process.env.BASE_URL
    };
  },
  mounted() {
    this.isMobile = window.innerWidth < 1200;
  },
  props: {
    step: {
      required: true,
      type: String
    }
  }
};
</script>

<style scoped>
.after-login-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.banner-inner {
  position: relative;
  line-height: 0;
}
.banner-inner img {
  display: block;
  width: auto;
  max-width: 100%;
  max-height: 95vh;
  border-radius: 16px;
}
.banner-close {
  position: absolute;
  top: 12px;
  right: 14px;
  z-index: 2;
  line-height: 0;
}
.banner-close svg {
  width: 22px;
  height: 22px;
}
.banner-close ::v-deep g rect,
.banner-close ::v-deep g path {
  fill: var(--blue-dark, #2a2e80);
}
</style>
